import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { CloudHelpers } from "@/core/modules/helpers/CloudHelpers";

export const isBadgeNumberUnique = async (badgeNumber: number, employeeId = "empty"): Promise<boolean> => {
  try {
    if (badgeNumber === undefined) return false;

    return CloudHelpers.runValidatorFunction("featuresEmployeeBadgeNumberValidator", badgeNumber.toFixed(0), employeeId);
  } catch (error: unknown) {
    appFaultModel.catchAppError("EmployeeModel.isBadgeNumberUnique", { badgeNumber, employeeId }, error);
    return false;
  }
};
